import { test } from 'ramda';

import { APPLICATION_PATHS, SECTIONS_PATHS } from '@framework/constants/enums';
import getCanAccessBasedOnRoomPermissions from '@framework/guards/modules/common/activeRoomPermissionsGuard';
import { type RouteHandler } from '@framework/guards/type';

import { PERMISSIONS } from '@type/permissions';

export const membersPermissionsGuard = [
    PERMISSIONS.CAN_CREATE_MEETINGS,
    PERMISSIONS.CAN_UPDATE_MEETINGS
];

export const membersGuard: RouteHandler<[], boolean> = {
    test: test(
        new RegExp(
            `/${APPLICATION_PATHS.ADMINISTRATOR}/${APPLICATION_PATHS.ROOMS}/([^/]+)/${SECTIONS_PATHS.MEMBERS}/`
        )
    ),
    handler: async (_ctx, contextMethods) => {
        const { call } = contextMethods;

        const canAccess = await call(getCanAccessBasedOnRoomPermissions, membersPermissionsGuard);
        return canAccess;
    }
};
